import { Component } from '@angular/core';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { ActivatedRoute } from '@angular/router';
import { InputComponent } from '../../utilities/input/input.component';
import { DropdownComponent } from '../../utilities/dropdown/dropdown.component';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '../../utilities/button/button.component';
import { SelectComponent } from '../../utilities/select/select.component';
import { VaultService } from '../../services/vault.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { RelayService } from '../../services/relay.service';
import { GeneralService } from '../../services/general.service';

@Component({
  selector: 'app-create-relay',
  standalone: true,
  imports: [
    DashboardComponent,
    InputComponent,
    DropdownComponent,
    CommonModule,
    ButtonComponent,
    SelectComponent,
  ],
  templateUrl: './create-relay.component.html',
  styleUrl: './create-relay.component.scss',
})
export class CreateRelayComponent {
  fetchingData: boolean = false;
  vaults: any;
  vaultNames: any;
  loading: boolean = false;
  relayType: string = '';
  selectedTransformer: string = 'JSON';
  filterType: any = ['REQUEST', 'RESPONSE'];
  actionType: any = ['ENCRYPT', 'DECRYPT'];
  targets: any = ['body', 'headers', 'query'];
  conditions: any = ['AND', 'OR'];
  storageType: any = ['EPHEMERAL', 'PERSISTENT'];
  // transformers: any = ['Json', 'XML', 'RegExp', 'Form', 'HTML', 'PDF'];
  transformers: any = ['JSON', 'XML']
  rulesField: any = ['Status', 'HTTPMethod', 'ContentType', 'PathInfo'];
  selectedRuleDropdown: any;
  fieldPlaceholders: any = {
    Json: 'eg.. $.account_number',
    XML: 'eg.. /account-number',
    RegExp: 'eg.. ^[0-9]{7,14}$',
    Form: 'eg.. account-number',
    HTML: 'eg.. .account-number',
    PDF: '',
  };
  contentTypeData: any = [
    'application/x-www-form-urlencoded',
    'multipart/form-data',
    'application/xml',
    'text/xml',
    'application/json',
    'application/vnd.api+json',
    'text/javascript',
    'application/xhtml-xml',
    'text/html'
  ];
  selectedFieldPlaceholder: string = 'eg.. $.account_number';
  httpMethodData: any = [
    'GET',
    'HEAD',
    'POST',
    'PUT',
    'DELETE',
    'CONNECT',
    'OPTIONS',
    'TRACE',
    'PATCH',
  ];
  tokenGenerator: any = [
    'Account Number - Numeric Length Preserving (A4) - xxxxxxxxxxxx<last_four>',
    'Generic - VGS Alias (Default) - tok_sandbox_xxxxxxxxxxxxxxxxxxxxxxxxx',
    'Generic - Numeric Length Preserving - xxxxxxxxxxxxxxxx',
    'Payment Card - Format Preserving - Non Luhn Valid - xxxxxxxxxxxxxxxx',
  ];
  rulesOperator: any = [
    'equals',
    'notEqual',
    'beginsWith',
    'notBeginsWith',
    'matches',
    'endsWith',
    'notEndsWith',
    'empty',
    'notEmpty',
    'notContains',
  ];
  newRelay: any = {
    name: '',
    type: '',
    vaultId: '',
    sourceIp: [],
    destinationDomain: '',
    filters: [
      {
        type: '',
        action: '',
        storage: '',
        tokenGenerator: '',
        transformer: '',
        transformerSelections: [{ type: '', selector: '' }],
        targets: [''],
        config: {
          condition: '',
          rules: [{ field: '', type: '', operator: '', value: '' }],
        },
      },
    ],
  };
  filterErors:any[] = [{}]
  errors: any = {
    name: '',
    type: '',
    vaultId: '',
    sourceIp: [],
    destinationDomain: '',
    filters: [
      {
        type: '',
        action: '',
        storage: '',
        tokenGenerator: '',
        transformer: '',
        transformerSelections: [{ type: '', selector: '' }],
        targets: [''],
        config: {
          condition: '',
          rules: [{ field: '', type: '', operator: '', value: '' }],
        },
      },
    ],
  };
 

  constructor(
    private route: ActivatedRoute,
    private vaultService: VaultService,
    private notification: NzNotificationService,
    private relayService: RelayService,
    private generalService: GeneralService
  ) {
    this.newRelay.type = this.route.snapshot.paramMap.get('type') ?? '';
    this.getVaults();
    this.newRelay.filters[0].action = this.actionType[1];
    this.newRelay.filters[0].config.rules[0].field = this.rulesField[1];
    this.newRelay.filters[0].transformer = this.transformers[0];
    this.newRelay.filters[0].transformerSelections[0].type = this.transformers[0];
  }
  addTransformerSelection(filterIndex: number) {
    this.newRelay?.filters[filterIndex]?.transformerSelections?.push({
      type: this.selectedTransformer ? this.selectedTransformer : '',
      selector: '',
    });
  }
  addTarget(filterIndex: number) {
    this.newRelay?.filters[filterIndex]?.targets?.push('');
  }
  addRule(filterIndex: number) {
    this.newRelay?.filters[filterIndex]?.config?.rules?.push({
      field: '',
      type: '',
      operator: '',
      value: '',
    });
  }
  addFilter() {
    this.newRelay.filters.push({
      type: '',
      action: '',
      storage: '',
      tokenGenerator: '',
      transformer: '',
      transformerSelections: [{ type: '', selector: '' }],
      targets: [''],
      config: {
        condition: '',
        rules: [{ field: '', type: '', operator: '', value: '' }],
      },
    });
  }
  removeFilter(index: number) {
    if (this.newRelay.filters.length > 1) {
      this.newRelay.filters.splice(index, 1);
    }
  }
  removeRule(index: number, filterIndex: number) {
    if (this.newRelay?.filters[filterIndex]?.config?.rules.length > 1) {
      this.newRelay?.filters[filterIndex]?.config?.rules.splice(index, 1);
    }
  }
  removeTarget(index: number, filterIndex: number) {
    if (this.newRelay?.filters[filterIndex]?.targets.length > 1) {
      this.newRelay?.filters[filterIndex]?.targets.splice(index, 1);
    }
  }
  removeTransformerSelection(index: number, filterIndex: number) {
    if (this.newRelay?.filters[filterIndex]?.transformerSelections.length > 1) {
      this.newRelay?.filters[filterIndex]?.transformerSelections.splice(
        index,
        1
      );
    }
  }
  separateByComma(input: string): string[] {
    return input.split(',').map((item) => item.trim());
  }
  setIpAddresses = (values: any) => {
    this.newRelay.sourceIp = this.separateByComma(values);
  };
  // setApiKey(data: string) {
  //   this.apiKey = data;
  // }
  handleInput(data: { title: string; value: string }) {
    if (data.title === 'vaultId') {
      this.newRelay[data.title] = this.getVaultId(data.value);
    } else {
      this.newRelay[data.title] = data.value;
    }
    if (data.value === '') {
      // this.errors[data.title] = 'Required*';
      return;
    } else {
      // this.errors[data.title] = '';
    }
  }
  trackByFn(index: number, item: any) {
    return index;
  }
  handleTarget(
    data: { title: string; value: string },
    filterIndex: number,
    targetIndex: number
  ) {
    this.newRelay.filters[filterIndex].targets[targetIndex] = data.value;
    if (data.value === '') {
      // this.errors[data.title] = 'Required*';
      return;
    } else {
      // this.errors[data.title] = '';
    }
  }
  handleRules(
    data: { title: string; value: string },
    filterIndex: number,
    ruleIndex: number
  ) {
    if (data.value === 'HTTPMethod') {
      this.selectedRuleDropdown = this.httpMethodData;
    }
    if (data.value === 'ContentType') {
      this.selectedRuleDropdown = this.contentTypeData;
    }
    this.newRelay.filters[filterIndex].config.rules[ruleIndex][data.title] =
      data.value;
    if (data.value === '') {
      // this.errors[data.title][ruleIndex] = 'Required*';
      return;
    } else {
      // this.errors[data.title][ruleIndex] = '';
    }
  }
  handleConfig(data: { title: string; value: string }, filterIndex: number) {
    this.newRelay.filters[filterIndex].config.condition = data.value;
    if (data.value === '') {
      // this.errors[data.title] = 'Required*';
      return;
    } else {
      // this.errors[data.title] = '';
    }
  }
  handleTransformerType(
    data: { title: string; value: string },
    filterIndex: number
  ) {
    if (data.value in this.fieldPlaceholders) {
      this.selectedFieldPlaceholder = this.fieldPlaceholders[data.value];
    }
    this.selectedTransformer = data.value;
    this.newRelay.filters[filterIndex].transformer = `${data.value}Transformer`;
    this.newRelay.filters[filterIndex].transformerSelections.forEach(
      (selection: any) => {
        selection.type = data.value.toUpperCase();
      }
    );
    if (data.value === '') {
      // this.errors[data.title] = 'Required*';
      return;
    } else {
      // this.errors[data.title] = '';
    }
  }
  handleTransformerSelections(
    data: { title: string; value: string },
    filterIndex: number,
    transformerIndex: number
  ) {
    this.newRelay.filters[filterIndex].transformerSelections[transformerIndex][
      data.title
    ] = data.value;
    if (data.value === '') {
      // this.errors[data.title][transformerIndex] = 'Required*';
      return;
    } else {
      // this.errors[data.title][transformerIndex] = '';
    }
  }
  handleBaseFilterData(
    data: { title: string; value: string },
    filterIndex: number
  ) {
    this.newRelay.filters[filterIndex][data.title] = data.value;
    if (data.value === '') {
      // this.errors[data.title] = 'Required*';
      return;
    } else {
      // this.errors[data.title] = '';
    }
  }
  getVaults() {
    this.fetchingData = true;
    this.vaultService.getVaults().subscribe({
      next: (res: any) => {
        this.fetchingData = false;
        this.vaults = res.data;
        this.vaultNames = this.vaults.map((vault: { name: any }) => vault.name);
      },
      error: (err) => {
        this.fetchingData = false;
        this.notification.error('Error', 'Failed to fetch vault data', {
          nzClass: 'notification',
        });
      },
    });
  }
  getVaultId(name: string) {
    const vault = this.vaults.find(
      (vault: { name: string }) => vault.name === name
    );
    return vault ? vault._id : null;
  }
  validateRelay() {
    this.errors = this.deepClone(this.newRelay); // Ensure a deep copy
  
    // Validate top-level properties
    Object.keys(this.newRelay).forEach((key) => {
      if (Array.isArray(this.newRelay[key])) {
        if (this.newRelay[key]?.length ===0) {
          this.errors[key] = 'Required';
        } else {
          this.errors[key] = this.newRelay[key].map((item: any, index: number) => {
            if (typeof item === 'object') {
              return this.validateObject(item); 
            }
            return item ? '' : 'Required';
          });
        }
      } else {
        this.errors[key] = this.newRelay[key] !=="" ? '' : 'Required';
      }
    });
  
    console.log(this.errors);
  }
  
  validateObject(obj: any) {
    const errorObj: any = {};
    Object.keys(obj).forEach((key) => {
      if (Array.isArray(obj[key])) {
        errorObj[key] = obj[key]?.map((item: any) => {
          if (typeof item === 'object') {
            return this.validateObject(item);
          }
          return item ? '' : 'Required';
        }) || [];
      } else {
        errorObj[key] = obj[key] ? '' : 'Required';
      }
    });
    return errorObj;
  }
  
  deepClone(obj: any) {
    return JSON.parse(JSON.stringify(obj));
  }

  validateFields(obj: any): boolean {
    const isEmpty = (value: any): boolean => {
      return (
        value === '' || 
        value === null || 
        value === undefined || 
        (Array.isArray(value) && value.length === 0)
      );
    };
  
    const checkObject = (obj: any): boolean => {
      for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          const value = obj[key];
  
          if (typeof value === 'object' && value !== null) {
            if (Array.isArray(value)) {
              if (value.length === 0 || value.some((item) => isEmpty(item) || (typeof item === 'object' && !checkObject(item)))) {
                return false;
              }
            } else {
              if (!checkObject(value)) {
                return false;
              }
            }
          } else {
            if (isEmpty(value)) {
              return false;
            }
          }
        }
      }
      return true;
    };
  
    return checkObject(obj);
  }
  
  createRelay = () => {
    if (!this.validateFields(this.newRelay)) {
      console.log(this.newRelay);
      this.notification.warning('Please Fill All Fields', '', {
        nzClass: 'notification',
      });
      return;
    }
    this.loading = true;
    this.relayService.createRelay(this.newRelay).subscribe(
      (res: any) => {
        this.notification.success('Success', 'Relay Created', {
          nzClass: 'notification',
        });
        this.loading = false;
        this.generalService.routeTo('relay')
      },
      (error) => {
        this.loading = false;
        this.notification.error('Error', 'Something went wrong', {
          nzClass: 'notification',
        });
      }
    );
  };
}
